<template>
  <div>
    <!-- 广告幻灯片 -->
    <van-swipe :autoplay="3000" lazy-render ref="carousel" class="scroll_banners" v-if="advertList && advertList.length !== 0">
      <van-swipe-item v-for="(item,index) in advertList" :key="item.id">
        <div v-if="item.href === ''">
          <img :src="item.image" v-if="!item.image_mobile || item.image_mobile === '0'">
          <img :src="item.image_mobile" v-else>
        </div>
         <a  href="#" @click="updateAdvert(item)" v-else>
           <img v-if="!item.image_mobile || item.image_mobile === '0'" :src="item.image">
           <img v-else :src="item.image_mobile">
         </a>
         <!--<a :href="item.href" v-if="item.href !== '' && item.mode===1" target="_blank"><img :src="item.image"></a>-->
         <!--<a :href="item.href" v-if="item.href !== '' && item.mode===2" target="" ><img :src="item.image"></a>-->
      </van-swipe-item>
    </van-swipe>
    <div class="container">
      <!-- 特点 -->
      <div class="feature_wrap">
        <div class="feature clearfix">
          <div class="item">
            <i class="iconfont icon-icon-10 orange"></i>
            <h3>在线直播实时答疑</h3>
            <p>课后视频反复观看</p>
          </div>
          <div class="item">
            <i class="iconfont icon-icon-11 green"></i>
            <h3>实战项目驱动</h3>
            <p>真实工业场景案例</p>
          </div>
          <div class="item">
            <i class="iconfont icon-icon-12 red"></i>
            <h3>业界一线工程师</h3>
            <p>实战经验倾囊相授</p>
          </div>
          <div class="item">
            <i class="iconfont icon-icon-13 blue"></i>
            <h3>实验平台辅助教学</h3>
            <p>告别繁杂的环境搭建</p>
          </div>
          <div class="item">
            <i class="iconfont icon-icon-14 purple"></i>
            <h3>专属课程助教</h3>
            <p>为您高效学习保驾护航</p>
          </div>
        </div>
      </div>
      <!-- 免费课程 -->
      <div class="well_gray">
        <h1>免费课程<a href="/mobile/course/list?price=free" target="_blank">查看更多</a></h1>
        <van-row gutter="15">
          <van-col span="12" v-for="(item, index) in freeCourse" :key="index">
            <div class="card_item_common">
              <div class="cover" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">
                <img :src="item.cover_image" class="image">
                <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
                <span class="tag" v-if="item.type">{{ item.type }}</span>
              </div>
              <div class="content">
                <div class="title text_ellipsis" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">{{ item.name }}</div>
                <div class="price_wrap">
                  <van-tag v-if="item.final_price == 0">免费</van-tag>
                  <span class="discount_price" v-else><span>¥</span>{{ item.final_price }}</span>
                  <span class="price" v-if="item.mark_price">¥ {{ item.mark_price }}</span>
                </div>
              </div>
            </div>
          </van-col>
          <van-col span="12" v-if="freeCourse.length % 2 !== 0"></van-col>
        </van-row>
        <!-- 最新课程 -->
        <h1>最新课程<a href="/mobile/course/list?sort=new" target="_blank">查看更多</a></h1>
        <van-row gutter="15">
          <van-col span="12" v-for="(item, index) in newCourse" :key="index">
            <div class="card_item_common">
              <div class="cover" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">
                <img :src="item.cover_image" class="image">
                <span class="hot" v-if="item.cover_image_label && item.cover_image_label != 'null'">{{ item.cover_image_label }}</span>
                <span class="tag" v-if="item.type">{{ item.type }}</span>
              </div>
              <div class="content">
                <div class="title text_ellipsis" @click="goPathToNewPage('/mobile/course/detail/' + item.uuid)">{{ item.name }}</div>
                <div class="price_wrap">
                  <van-tag v-if="item.final_price == 0">免费</van-tag>
                  <span class="discount_price" v-else><span>¥</span>{{ item.final_price }}</span>
                  <span class="price" v-if="item.mark_price">¥ {{ item.mark_price }}</span>
                </div>
              </div>
            </div>
          </van-col>
          <van-col span="12" v-if="newCourse.length % 2 !== 0"></van-col>
        </van-row>
        <!-- 讲师天团 -->
        <h1>讲师天团<a href="/mobile/aboutus?isActiveName=课程讲师" target="_blank">查看更多</a></h1>
        <van-row>
          <van-col span="24" v-for="item in portrait" :key="item.id">
            <PortraitItem :item="item"></PortraitItem>
          </van-col>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
  import { goPathToNewPage } from 'utils/common'
  import { listUserCur } from "api/course/course/list"
  import { listTeacher, get_favor_like } from "api/course/course/create"
  import PortraitItem from 'components/mobile/PortraitItem'
  import { getAdvertList, updateHitNum } from 'api/advert/admin'
  export default {
    components: {
      PortraitItem
    },
    data() {
      return {
        freeCourse: [],
        newCourse: [],
        portrait: [],
        advertList: [],
      }
    },
    mounted() {
      this.$emit('update:isShowHeader', true);
      const that = this;
      this.getAdvertList()
      this.listFreeCur()
      this.listNewCur()
      this.getTeacherList()
    },
    methods: {
      goPathToNewPage,
      getFavorLike(courseItem){
        courseItem.forEach(item => {
          get_favor_like(item.uuid).then(res => {
            item.like = res.like.num
            item.favor = res.favor.num
            item.view = res.view_num
          })
        })
      },
      listFreeCur() {
        let data = {
          final_price: 0,
          state: 3,
          need_count: false,
          limit: 4,
          offset: 0,
          need_info: true,
          need_type: true
        }
        listUserCur(data).then(res => {
          this.freeCourse = res.data
          this.getFavorLike(this.freeCourse)
        })
      },
      listNewCur() {
        let data = {
          final_price: '>0',
          sort_key: 'publish_at',
          state: 3,
          need_count: false,
          limit: 4,
          offset: 0,
          need_info: true,
          need_type: true
        }
        listUserCur(data).then(res => {
          this.newCourse = res.data
          this.getFavorLike(this.newCourse)
        })
      },
      getTeacherList() {
        const that = this
        var filters = {
          limit: 4,
          offset: 0
        }
        listTeacher(filters).then(res => {
          that.portrait = res.data
          console.log(that.portrait)
        })
      },
      getAdvertList() {
        const that = this
        let filters = {
          location: 0,
          state:  1,
          order: true
        }
        getAdvertList(filters).then(res => {
          that.advertList = res.data

          console.log("====================",res.data)

          for(let item of that.advertList) {
            const begin = item.href.substring(0, 1)
            if(begin === '/') {
              item.href = `/mobile${item.href}`
            }
          }

        })
      },
      updateAdvert(adv) {
        let data = new FormData();
        data.append('up_hit_num', '1');
        const id = adv.id
        updateHitNum(id, data).then(() => {
        })

        if(adv.mode === 1){
          if(adv.href){
            window.open(adv.href)
          }
        }
        else {
          if(adv.href){
            location.href = adv.href
          }
        }

      },
      goPath(path) {
        this.$router.push(path);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .feature_wrap {
    overflow-y:hidden;
    overflow-x:auto;
    padding-bottom:15px;
    .feature {
      width:1060px;
      .item {
        width:200px;
        float:left;
        margin-left:15px;
        padding:30px 0 40px 0;
        background:#f5f6f6;
        border-radius:20px 0 20px 20px;
        text-align: center;
        > i {
          display:block;
          font-size:52px;
          margin-bottom:30px;
          &.orange {
            color:#fda83b;
          }
          &.green {
            color:#77bd77;
          }
          &.red {
            color:#f15a51;
          }
          &.blue {
            color:#009dd9;
          }
          &.purple {
            color:#7453bc;
          }
        }
        h3 {
          color:#333;
          font-size:18px;
          margin-top:0;
          margin-bottom:20px;
        }
        p {
          margin:0;
        }
        &:first-child {
          margin-left:0;
        }
      }
    }
  }
  .well_gray {
    background-color:#f8f8f8;
    margin-left:-15px;
    margin-right:-15px;
    margin-bottom:-15px;
    padding:15px;
    > h1 {
      font-size:20px;
      color:#333;
      margin-top:10px;
      > a {
        float:right;
        font-size:14px;
        font-weight: normal;
        padding-top:3px;
      }
    }
  }
</style>
